export default [{
  path: '/settlement',
  name: 'settlement',
  component: () => import('@/pages/settlement/index/index.vue'),
  meta: {
    title: '结算管理',
    pageId: 'todo',
    spm: 2287,
  },
},
{
  path: '/settlement/addAccount',
  name: 'settlementAddAccount',
  component: () => import('@/pages/settlement/addWithdrawAccount/index.vue'),
  meta: {
    pageId: 'todo',
    spm: 2288,
  },
},
{
  path: '/settlement/addAccount/enterprise',
  name: 'settlementAddAccountEnterprise',
  component: () => import('@/pages/settlement/addWithdrawAccount/enterprise.vue'),
  meta: {
    pageId: 'todo',
    spm: 2289,
  },
},
{
  path: '/settlement/withdraw',
  name: 'settlementWithdraw',
  component: () => import('@/pages/settlement/withdraw/index.vue'),
  meta: {
    pageId: 'todo',
    spm: 2290,
  },
},
{
  path: '/settlement/platformList',
  name: 'settlementPlatformList',
  component: () => import('@/pages/settlement/platformList'),
  meta: {
    header: '结算平台',
    spm: 2291,
  },
},
{
  path: '/settlement/withdrawRecord',
  name: 'settlementWithdrawRecord',
  component: () => import('@/pages/settlement/withdrawRecord/index.vue'),
  meta: {
    title: '提现记录',
    pageId: 'todo',
    spm: 2292,
  },
}, {
  // 快结快付规则
  path: '/settlement/withdrawRule-1',
  name: 'settlementWithdrawRule-1',
  component: () => import('@/pages/settlement/withdrawRule/kjkf.vue'),
  meta: {
    header: '结算规则',
    spm: 2293,
  },
}, {
  // 聚鑫规则
  path: '/settlement/withdrawRule-2',
  name: 'settlementWithdrawRule-2',
  component: () => import('@/pages/settlement/withdrawRule/jx.vue'),
  meta: {
    header: '结算规则',
    spm: 2294,
  },
}, {
  path: '/settlement/manageWithdraw',
  name: 'settlementManageWithdraw',
  component: () => import('@/pages/settlement/manageWithdraw/index.vue'),
  meta: {
    header: '管理提现方式',
    pageId: 'todo',
    spm: 2295,
  },
}];
